import React from 'react';
import './B_A.css';
import image2 from '../../Assets/image2.jpg'; // Assuming this is an image file

const Background = ({ PlayState, HeroCount }) => (
  <img className='BackImage' src={image2} alt='Background' />
);

export default Background;
